if (!customElements.get('product-reviews-summary')) {
  customElements.define(
    'product-reviews-summary',
    class ProductReviewsSummary extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', () => this.scrollToReviews());
      }

      scrollToReviews() {
        const reviewsSection = document.querySelector('product-reviews');
        if (!reviewsSection) return;
        reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
  );
}
